const throbberCls = "gfxts9zx0z";

export { throbberCls };
import "./Throbber.linaria.module.css";
//# sourceMappingURL=Throbber.js.map
